import { NgRedux } from '@angular-redux/store';
import { Component, Inject, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Unsubscribe } from 'redux';
import { Observable } from 'rxjs/Observable';
import { APP_CONFIG } from '../../../api/config';
import { Brands } from '../../../api/enums/';
import { Hotel } from '../../../api/model/hotel/';
import { BaazarvoiceService } from '../../../api/services/baazarvoice.service';
import { HotelService } from '../../../api/services/hotel.service';
import { mapToTypeFromString } from '../../../common';
import { MessagesUtil } from '../../../common/messages.util';
import { ApplicationLocale } from '../../../common/model/';
import { IAppState } from '../../../store';
import { IAppConfig } from '../../../store/interfaces/IAppConfig';

@Component({
  selector: 'submit-review',
  templateUrl: './submit-review.component.html',
  styleUrls: ['./submit-review.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubmitReviewComponent implements OnInit, OnDestroy {
  public bvCode: string;
  public hotelCode: string;
  public hotel: Observable<Hotel>;
  public chainCode: string;
  public translations: { [key: string]: string };
  private state: IAppState;
  private unsubscribe: Unsubscribe;

  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig,
    private route: ActivatedRoute,
    private baazarvoiceService: BaazarvoiceService,
    private hotelService: HotelService,
    private _ngRedux: NgRedux<IAppState>) {
  }

  ngOnInit() {
    this.bvCode = this.baazarvoiceService.getBVoiceValue(this.getBrand(), this.getLocale());

    this.route.params.subscribe(params => {
      this.hotelCode = params['hotelCode'];
      this.hotel = this.hotelService.getHotel(this.hotelCode);
      this.hotel.subscribe(hotel => {
        this.chainCode = hotel.chainCode;
      });
    });

    this.unsubscribe = this._ngRedux.subscribe(() => {
      this.updateFromState();
    });
  }

  ngOnDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  public updateFromState() {
    this.state = this._ngRedux.getState();
    if (!this.state) {
      return;
    }
    this.translations = MessagesUtil.filterTranslations(this.state.translations, 'hotelreview');
  }

  private getBrand(): Brands {
    return mapToTypeFromString<Brands>(Brands, this.appConfig.brand.brandCode);
  }

  private getLocale(): ApplicationLocale {
    return ApplicationLocale.fromString(this.appConfig.locale.localeString);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/submit-review/submit-review/submit-review.component.ts